import React from 'react';
import '../../App.css';
import ProgressBar from './ProgressBar';
import Container from "react-bootstrap/Container";
import { useEffect } from 'react';


export default function Skills() {
  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
  }, []);
  return (
    <div>
        <h1 className="skills">My Skills</h1>
      {/* <Progress /> */}
      <br></br>
      <Container>
           <ProgressBar />
    </Container>
    </div>
  );
}
